var Account, Breadcrumbs, DateView, GalleryThumbsPage, GridView, HeadingBar, NoAccount, Page, ViewOptions, m;

m = require('mithril');

Account = require('../../state/Account');

Page = require('../components/Page');

NoAccount = require('../components/NoAccount');

HeadingBar = require('../components/HeadingBar');

Breadcrumbs = require('../components/Breadcrumbs');

ViewOptions = require('../components/ViewOptions');

GridView = require('../components/GridView');

DateView = require('../components/DateView');

GalleryThumbsPage = {
  controller: function(args) {
    var ctrl, galleryId, ref, ref1, view;
    ref = m.route.param(), view = (ref1 = ref.view) != null ? ref1 : 'grid', galleryId = ref.galleryId;
    ctrl = this;
    ctrl.view = m.prop(view);
    ctrl.onViewSelect = function(view) {
      return m.route("/gallery/" + galleryId + "/thumbs", {
        view: view
      });
    };
    ctrl.onPhotoSelect = function(photo) {
      return m.route("/gallery/" + galleryId + "/photos/" + photo.name);
    };
    return ctrl;
  },
  view: function(ctrl, args) {
    var account, gallery, photos, viewArgs;
    account = args.account();
    if (account == null) {
      return m(NoAccount);
    }
    gallery = args.gallery();
    photos = gallery.photos;
    viewArgs = {
      photos: photos,
      onPhotoSelect: ctrl.onPhotoSelect,
      bucketType: 'month'
    };
    return m(Page, {
      account: account,
      content: [
        m(HeadingBar, {
          content: m(Breadcrumbs, {
            items: [
              {
                icon: 'home',
                title: 'Home',
                onclick: function() {
                  return m.route('/home');
                }
              }, {
                icon: 'gallery',
                content: gallery.name
              }
            ]
          })
        }), m(ViewOptions, {
          view: ctrl.view,
          onViewSelect: ctrl.onViewSelect
        }), (function() {
          switch (ctrl.view()) {
            case 'grid':
              return m(GridView, viewArgs);
            case 'date':
              return m(DateView, viewArgs);
            default:
              return "Unknown view: " + (ctrl.view());
          }
        })()
      ]
    });
  }
};

module.exports = function(store) {
  return m(GalleryThumbsPage, {
    account: function() {
      return store.getState().account;
    },
    gallery: function() {
      var galleries, galleryId;
      galleryId = m.route.param().galleryId;
      galleries = store.getState().galleries;
      return Account.getGallery(galleries, galleryId);
    }
  });
};

//# sourceMappingURL=data:application/json;base64,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
